// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__SLQMy","bottom":"Footer_bottom__dfqjs","links":"Footer_links__k3jZg","socialLinks":"Footer_socialLinks__76+bc"};